import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2104LogicalUnit } from "../../../../U2104Service";
import type { U2104RoleActionHandler } from "./U2104RoleActionHandlers";

// Typage des props du composant
interface U2104RoleActionDeleteDlgProps {
  u2104RoleActionHandler: U2104RoleActionHandler;
  t: TFunction;
  NS: string;
}

// Composant pour la boîte de dialogue de suppression d'une action de rôle
function U2104RoleActionDeleteDlg({ u2104RoleActionHandler, t, NS }: U2104RoleActionDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2104RoleActionHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2104RoleActionHandler.isDeleteDialogOpen} onClose={u2104RoleActionHandler.onDlgDeleteClose} title={t("role.lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("role.msgDeleteRole", {
          count: u2104RoleActionHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2104RoleActionHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const lu = row as unknown as U2104LogicalUnit;
          return (
            <span key={lu.logicalUnitCode} className="inline-block text-gray-800">
              {`${lu.logicalUnitCode} - ${lu.logicalUnitDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2104RoleActionDeleteDlg;
